import { createAction } from 'redux-actions';
import { SET_GROUP_NAME } from './actionTypes';

const setGroupName = createAction(SET_GROUP_NAME);

// eslint-disable-next-line import/prefer-default-export
export { setGroupName };
